import type { FC } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Alert, Anchor, FullBleed } from '@myphx-engineering/phx-design-system';

import { getAbsoluteRoute } from '../../util/get-absolute-route';

export type SendToPharmacyErrorProps = {
    show: boolean;
};

export const SendToPharmacyError: FC<SendToPharmacyErrorProps> = ({ show }) => {
    const navigate = useNavigate();

    const goToSupport = () => navigate(getAbsoluteRoute('support'));

    if (!show) {
        return null;
    }

    return (
        <FullBleed breakpoint="md" color="error" spacing="none">
            <Alert severity="error">
                <Trans
                    i18nKey="sendToPharmacy.error"
                    components={{
                        1: (
                            <Anchor
                                onClick={goToSupport}
                                textDecoration="underline"
                            />
                        ),
                    }}
                />
            </Alert>
        </FullBleed>
    );
};
